import React, { useEffect, useRef, useState } from 'react';
import styles from './EventDetails.module.css';
import iglesiaImg from '../../assets/iglesiaaa.jpg';
import salonImg from '../../assets/recepciooon.jpg';

const EventDetails: React.FC = () => {
  const [isFirstVisible, setIsFirstVisible] = useState(false);
  const [isSecondVisible, setIsSecondVisible] = useState(false);
  const firstCardRef = useRef<HTMLDivElement>(null);
  const secondCardRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    const observerFirst = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            setIsFirstVisible(true);
            observerFirst.unobserve(entry.target);
          }
        });
      },
      {
        threshold: 0.2,
        rootMargin: '0px 0px -50px 0px'
      }
    );

    const observerSecond = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            setIsSecondVisible(true);
            observerSecond.unobserve(entry.target);
          }
        });
      },
      {
        threshold: 0.2,
        rootMargin: '0px 0px -50px 0px'
      }
    );

const firstRef = firstCardRef.current;
const secondRef = secondCardRef.current;

if (firstRef) {
  observerFirst.observe(firstRef);
}

if (secondRef) {
  observerSecond.observe(secondRef);
}

return () => {
  if (firstRef) {
    observerFirst.unobserve(firstRef);
  }
  if (secondRef) {
    observerSecond.unobserve(secondRef);
  }
};
  }, []);

  return (
    <section className={styles.eventDetails}>
      <div className="container">
        <h3 className={styles.sectionTitle}>Dónde y Cuándo</h3>
        
        <div 
          ref={firstCardRef}
          className={`${styles.eventCard} ${isFirstVisible ? styles.animate : ''}`}
        >
          <div className={styles.eventImage}>
            <img src={iglesiaImg} alt="Parroquia de San Miguel Arcángel Carrillo A.R." />
          </div>
          <div className={styles.eventInfo}>
            <h4>Ceremonia Religiosa</h4>
            <p className={styles.venue}>Parroquia de San Miguel Arcángel Carrillo A.R.</p>
            <p className={styles.time}>16:00 hrs</p>
            <p className={styles.address}>
              Guadalupe Victoria 14, Felipe Carrillo Puerto,<br />
              76138 Santiago de Querétaro, Qro.
            </p>
            <a href="https://maps.app.goo.gl/ppZk6vQ8n4S9ozgv6" target="_blank" rel="noopener noreferrer">
              <button className={styles.mapButton}>VER MAPA</button>
            </a>
          </div>
        </div>
        
        <div 
          ref={secondCardRef}
          className={`${styles.eventCard} ${styles.secondCard} ${isSecondVisible ? styles.animate : ''}`}
        >
          <div className={styles.eventImage}>
            <img src={salonImg} alt="Salón Villa Caro" />
          </div>
          <div className={styles.eventInfo}>
            <h4>Recepción</h4>
            <p className={styles.venue}>Salón Villa Caro</p>
            <p className={styles.time}>18:00 hrs</p>
            <p className={styles.address}>
              San Jose, Colinas de Sta. Cruz #4, 1ra seccion<br />
              76117 Santiago de Querétaro, Qro.
            </p>
            <a href="https://maps.app.goo.gl/oMoGZrz264RfWA8W6" target="_blank" rel="noopener noreferrer">
              <button className={styles.mapButton}>VER MAPA</button>
            </a>
          </div>
        </div>
      </div>
    </section>
  );
};

export default EventDetails;